import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("circAbx64bbsscPbQzZAUvuXpHqrCe6fLMzc2uKXz9g");
//# sourceMappingURL=constants.js.map